<template>
    <p class="text-sm font-normal first-letter:capitalize">
        {{ $t('label.showing') }}
        <b class="font-medium">{{ props.page.from }}</b>
        {{  props.page.from ? $t('label.to') : '' }}
        <b class="font-medium">{{ props.page.to }}</b>
        {{ props.page.to ? $t('label.of') : '' }}
        <b class="font-medium">{{ props.page.total }}</b>
        {{ $t('label.results') }}
    </p>
</template>

<script>
export default {
    name: "PaginationTextComponent",
    props: ['props'],
}
</script>
